import React, { useEffect, useState, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  DateInput,
  TextInput,
  SelectInput,
} from "../../components/common/UI/Inputs/InputControls";
import amountcash from "../../assets/images/money-icon.svg";
import info from "../../assets/images/Info.svg";
import warn from "../../assets/warning.svg";
import { myContactsActions, purchaseCreditsActions, sendPhotosActions } from "../../_store";
import useDraft from '../../components/common/autoSaveDraftMsg/useDraft';
import ConfirmationModal from "../../components/common/UI/Inputs/NotificationModal/BootstrapModalPopup";
import translations from '../../config/TranslateFile.jsx'
import { CreateEventLogTextFileForInbox, EventLog } from "../../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../../utils/routeTracker.js";
import { getStoredValue, removeStoredValue, setStoredValue } from "../../_helpers/storagehelper.js";
import useFullPageLoader from "../../hooks/useFullPageLoader.jsx";

const PurchaseCredits = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const InmateDrpList = useSelector((x) => x.myContacts.LoadPublicMyContactsDisplay);
  const myAccountDetails = useSelector((state) => state.myAccount.LoadPublicUserDetails);
  const MsgPhotoStatusResponse = useSelector((state) => state.sendPhotos.CheckingMsgPhotoStatusResponse);
  const currentLang = translations();
  const InitialFormData =
  {
    InmateID: "",
    InmatesName: "",
    InmateOption: null,
    CreditBalance: 0.00
  }
  const [formData, setFormData] = useState(InitialFormData);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isStatusPopup, setIsStatusPopup] = useState(false);
  const [isStatusDiv, setIsStatusDiv] = useState(false);
  const [purchaseStatusDiv, setPurchaseStatusDiv] = useState("");
  const [creditsDetails, setCreditsDetails] = useState(0);
  const [messageCost, setMessageCost] = useState(0);
  const [isDisabledCheckout, setIsDisabledCheckout] = useState(true);
  const [statusPopupMsg, setStatusPopupMsg] = useState("");
  const [isDisabledInmateID, setIsDisabledInmateID] = useState(false);
  const [creditAmount, setCreditAmount] = useState(0); // Initial credit amount is 0
  const processingFee = creditAmount === 0 ? 0 : InmateDrpList?.length > 0 ? InmateDrpList[0]?.ProcessingFee : 1.5;
  const [processingFees, setProcessingFees] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedAmount, setSelectedAmount] = useState(null);
  const UserID = getStoredValue("userID");
  const InmateID = getStoredValue("InmateID");
  const location = useLocation();
  const previousPath = location.state?.previousPath || "";
  const [loader, showLoader, hideLoader] = useFullPageLoader();


  const handlemsgResponse = (MsgPhotoStatusResponse) => {
    if (MsgPhotoStatusResponse) {
      const { Result, Notes } = MsgPhotoStatusResponse;
      switch (Result) {
        case -7:
          setPurchaseStatusDiv(currentLang?.PurchaseCreditsPopContent?.Connection_Blocked);
          setIsDisabledCheckout(true);
          setIsStatusDiv(true);
          EmptyPurchaseFields();
          setIsDisabledInmateID(false);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -8:
          setPurchaseStatusDiv(currentLang?.PurchaseCreditsPopContent?.No_longer_connected);
          DisablePurchaseFields();
          EmptyPurchaseFields();
          setIsDisabledInmateID(false);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -6:
          setPurchaseStatusDiv(currentLang?.ArchivedPagePopContent?.Disabled_Contact);
          DisablePurchaseFields();
          EmptyPurchaseFields();
          setSelectedAmount("");
          setIsDisabledInmateID(false);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -4:
          setPurchaseStatusDiv(currentLang?.ArchivedPagePopContent?.Disabled_Facility);
          DisablePurchaseFields();
          EmptyPurchaseFields();
          setSelectedAmount("");
          setIsDisabledInmateID(false);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -3:
          setPurchaseStatusDiv(Notes);
          EmptyPurchaseFields();
          DisablePurchaseFields();
          setIsDisabledInmateID(false);
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        default:
          if (Result === 0) {
            EnablePurchaseFields();
            setPurchaseStatusDiv("");
            dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          }
          break;
      }
      hideLoader();
    }
  }

  //  Disable Purchase Fields
  const DisablePurchaseFields = () => {
    setIsDisabledCheckout(true);
    //LoadInmateDrp();
    setIsStatusDiv(true);
  }
  // Enable Purchase Fields
  const EnablePurchaseFields = () => {
    setIsDisabledCheckout(true);
    setIsStatusDiv(false);
  }
  // Enable Purchase Fields
  const EmptyPurchaseFields = () => {
    setCreditAmount(0);
    setProcessingFees(0);
    setTotalAmount(0);
  }

  // Empty the form state
  const EmptyFormState = () => {
    setFormData(InitialFormData);
  }
  const handleStateReset = () => {
    removeStoredValue("InmateID");
    navigate(location.pathname, { state: { previousPath: '' } });
    storeCurrentRoute(location.pathname);
  };

  const handleCheckOut = () => {
    if (isProcessing) return; // Prevent further execution if already processing
    setIsProcessing(true); // Disable further clicks
    setIsDisabledCheckout(true);
    const paymentdata = {
      publicUserName: myAccountDetails.UserName,
      publicUserMailId: myAccountDetails.Email,
      publicUserPhoneNo: myAccountDetails.CellPhone,
      creditsValue: (creditAmount).toFixed(2),
      publicUserId: UserID,
      amount: (totalAmount).toFixed(2),
      dynamicProcessingFee: (processingFees).toFixed(2),
      InmatesId: formData.InmateID,
      resultType: "Stripe",
      ipAddress: "",
      browserType: "chrome",

      responseStripeRandomID: {
        stripeRandomId: ""
      }
    }

    //dispatch(purchaseCreditsActions.PaymentSubmitClick(paymentdata));
    dispatch(purchaseCreditsActions.PaymentSubmitClick(paymentdata))
      .then((response) => {
        setIsDisabledCheckout(false);
        const infoMessage = "Proceeded Checkout option to Choose Payments gateway options ";
        const redirectURL = "Show Payments gateway options in Popup";
        const Status = " Payment Gateway - Alert Message :- ";
        const Response = JSON.stringify(response?.payload);
        CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);
        const paymentDetailsUpdateResult = response?.payload.isSuceed;
        switch (paymentDetailsUpdateResult) {
          case 0:
            setIsStatusPopup(true);
            setStatusPopupMsg(response?.payload.notes);
            setPurchaseStatusDiv(response?.payload.notes);
            setIsDisabledInmateID(false);
            DisablePurchaseFields();
            handleStateReset();
            setIsProcessing(false); // Re-enable button after completion
            break;
          case -1:
            setIsStatusPopup(true);
            setStatusPopupMsg(currentLang?.ArchivedPagePopContent?.Disabled_Facility);
            setPurchaseStatusDiv(currentLang?.ArchivedPagePopContent?.Disabled_Facility);
            setIsDisabledInmateID(false);
            DisablePurchaseFields();
            handleStateReset();
            setIsProcessing(false); // Re-enable button after completion
            break;
          case -2:
            setIsStatusPopup(true);
            setStatusPopupMsg(currentLang?.PurchaseCreditsPopContent?.TransactionID_Already_exists);
            setIsDisabledInmateID(false);
            DisablePurchaseFields();
            handleStateReset();
            setIsProcessing(false); // Re-enable button after completion
            break;
          case -3:
            setIsStatusPopup(true);
            setStatusPopupMsg(currentLang?.PurchaseCreditsPopContent?.Connection_Blocked);
            setPurchaseStatusDiv(currentLang?.PurchaseCreditsPopContent?.Connection_Blocked);
            setIsDisabledCheckout(true);
            setIsDisabledInmateID(false);
            EmptyFormState();
            EmptyPurchaseFields();
            LoadInmateDrp();
            handleStateReset();
            setIsProcessing(false); // Re-enable button after completion
            break;
          case -4:
            setIsStatusPopup(true);
            setStatusPopupMsg(currentLang?.PurchaseCreditsPopContent?.Transaction_Date_Should_NotEmpty);
            setPurchaseStatusDiv(currentLang?.PurchaseCreditsPopContent?.Transaction_Date_Should_NotEmpty);
            DisablePurchaseFields();
            EmptyFormState();
            EmptyPurchaseFields();
            setIsDisabledInmateID(false);
            handleStateReset();
            setIsProcessing(false); // Re-enable button after completion
            break;
          case -6:
            setIsStatusPopup(true);
            setStatusPopupMsg(currentLang?.ArchivedPagePopContent?.Disabled_Contact);
            setPurchaseStatusDiv(currentLang?.ArchivedPagePopContent?.Disabled_Contact);
            DisablePurchaseFields();
            setIsDisabledInmateID(false);
            handleStateReset();
            setIsProcessing(false); // Re-enable button after completion
            break;
          case 1:
            setIsStatusPopup(false);
            setIsStatusDiv(false);
            EnablePurchaseFields();
            const intentData = {
              inmateID: formData.InmateID,
              amount: totalAmount.toFixed(2),
              emailid: myAccountDetails.Email,
              currency: "usd",
              stripeRandomOrderID: response?.payload?.stripeRandomId,
            };
            dispatch(purchaseCreditsActions.CreateClientSecretDetails(intentData))
              .then((response) => {
                const clientSecretID = response?.payload?.clientSecretID;
                if (clientSecretID) {
                  const infoMessage = 'Now calling Payment Intent api to make a payment';
                  const redirectURL = "---";
                  const Status = "Passing ClientSecretID for make a Payment in stripe ";
                  const Response = '---';
                  EventLog(dispatch, infoMessage, redirectURL, Response, Status);
                  setIsStatusPopup(false);
                  setStoredValue("StripeSelectInmateID", formData.InmateID)
                  setIsProcessing(false); // Re-enable button after completion
                  navigate("/StripeElementsWrapper", {
                    state: { clientSecret: clientSecretID, stripeRandomOrderID: intentData?.stripeRandomOrderID, totalAmount: totalAmount.toFixed(2), processingFee: InmateDrpList?.length > 0 ? InmateDrpList[0]?.ProcessingFee : 1.5 },
                  });
                  storeCurrentRoute("/StripeElementsWrapper");

                } else {
                  const infoMessage = 'payment failed';
                  const redirectURL = "---";
                  const Status = "";
                  const Response = '---';
                  EventLog(dispatch, infoMessage, redirectURL, Response, Status);
                  setIsStatusPopup(true);
                  setStatusPopupMsg("Failed to retrieve client secret!");
                  setIsProcessing(false); // Re-enable button after completion
                }
              })
              .catch((error) => {
                setIsStatusPopup(true);
                setStatusPopupMsg("An error occurred while processing your request.");
              });
            break;
          default:
            setIsStatusPopup(true);
            setStatusPopupMsg("Operation failed!");
            setIsProcessing(false); // Re-enable button after completion

        }

      })
      .catch((error) => {

        // Handle the error response here
      });
  };

  const handleClickClose = () => {
    setIsStatusPopup(false);
  }
  const handleSelectChange = (selectedOption, fieldName) => {
    const selectedValue = Array.isArray(selectedOption)
      ? selectedOption.map((option) => option.value) // For multi-select, store an array of values
      : selectedOption?.value ?? ""; // For single-select, store a single value or an empty string

    if (!selectedOption) {
      const infoMessage = "Un Selected Inmate Name ";
      const redirectURL = "---";
      CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL);
      setFormData((prevState) => ({
        ...prevState,
        [fieldName]: "",
      }));
    } else {
      const selectedInmate = InmateDrpList.find((inmate) => inmate.InmateID === selectedValue);
      const infoMessage = "Selected Inmate Name ( Inmate ID - " + selectedValue + " ) ";
      const Response = "Current Credit Balance - " + selectedInmate?.CreditBalance ? parseFloat(selectedInmate?.CreditBalance).toFixed(2) : "0.00";
      const redirectURL = "---";
      CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response);

      // Update the formData with the selected value
      setFormData((prevState) => ({
        ...prevState,
        [fieldName]: selectedValue, // Store the updated value for the field
      }));
      if (selectedInmate) {
        setFormData(selectedInmate);
        const fixedNumber = 5.00;

        // Validate the input and calculate
        const messageCost = parseFloat(selectedInmate.FacilityMessageCost);
        const calculatedValue = messageCost > 0 ? fixedNumber / messageCost : 0;

        // Set the values
        setCreditsDetails(parseInt(calculatedValue));

        setMessageCost(parseFloat(selectedInmate.FacilityMessageCost).toFixed(2))
        dispatch(purchaseCreditsActions.InmateDetails(selectedInmate));
        setIsDisabledCheckout(true);
        EmptyPurchaseFields();
        setSelectedAmount("");
      } else {
        EmptyPurchaseFields();
        setIsDisabledCheckout(true);
      }
      setFormData(selectedInmate !== undefined ? selectedInmate : {});
      if (selectedInmate !== undefined) {
        dispatch(purchaseCreditsActions.InmateDetails(selectedInmate))
        showLoader();
        dispatch(sendPhotosActions.CheckingMsgPhotoStatus({ addFormData: { UserID: UserID, InmateID: selectedValue } })).then((x => {
          handlemsgResponse(x?.payload)
        }))
      }
    }

    //  dispatch(findInmatesActions.clearEmailResponse());
  };

  // Auto Draft save
  const { setIsSaveDraftModified } = useDraft();
  useEffect(() => {
    const savedDraft = getStoredValue('draft');
    if (savedDraft != null) {
      setIsSaveDraftModified(true);
    }
  }, [setIsSaveDraftModified]);

  const LoadInmateDrp = () => {
    let inmatesID = 0;
    let userID = UserID;
    let ActiveStatus = 0;
    let SortField = "InmateName asc";
    let InmateLoadPurpose = "PurchaseCredit";
    dispatch(
      myContactsActions.LoadPublicMyContactsDisplay({
        userID,
        inmatesID,
        InmateLoadPurpose,
        ActiveStatus,
        SortField,
      })
    );
  }


  useEffect(() => {
    LoadInmateDrp();
  }, [dispatch]);
  const selectCreditAmount = (amount) => {
    const infoMessage = "Selected Credit limit to Purchase";
    const redirectURL = "---";
    const Response = "Selected Credit limit - " + amount;
    const Status = "---";
    CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);
    setCreditAmount(amount);
    const fee = InmateDrpList?.length > 0 ? InmateDrpList[0]?.ProcessingFee : 1.5; // Fixed processing fee
    setProcessingFees(fee);
    setTotalAmount(amount + fee);
    setSelectedAmount(amount); // Set the clicked amount as active
    if (amount !== 0) {
      setIsDisabledCheckout(false);
    }
    else {
      setIsDisabledCheckout(true);
    }
  };

  useEffect(() => {
    if (previousPath != "") {
      if (InmateID != null && InmateID != "") {
        const selectedInmate = InmateDrpList?.find((inmate) => inmate.InmateID === parseInt(InmateID));
        if (selectedInmate !== undefined) {
          setFormData((prevState) => ({
            ...prevState,
            InmateID: ((InmateID != null && InmateID != "") ? parseInt(InmateID) : ""),
            CreditBalance: selectedInmate?.CreditBalance
          }));

          const fixedNumber = 5.00;
          // Applying the formula to find the number
          const calculatedValue = fixedNumber / selectedInmate?.FacilityMessageCost;
          setCreditsDetails(calculatedValue <= fixedNumber ? 0 : calculatedValue);
          setMessageCost(parseFloat(selectedInmate?.FacilityMessageCost).toFixed(2));
          setIsDisabledInmateID(true);
        }
        else {
          setFormData((prevState) => ({
            ...prevState,
            InmateID: "",
            CreditBalance: "0.00",
          }));
          setCreditAmount(0);
          setProcessingFees(0);
          setTotalAmount(0);
          setIsDisabledCheckout(true);
          setIsDisabledInmateID(false);
        }
      }
    }
    else {
      setFormData((prevState) => ({
        ...prevState,
        InmateID: "",
        CreditBalance: "0.00",
      }));
      setCreditAmount(0);
      setProcessingFees(0);
      setTotalAmount(0);
      setIsDisabledCheckout(true);
      setIsDisabledInmateID(false);
    }
  }, [InmateID, previousPath, InmateDrpList]);


  return (
    <div>
      <>
        <div classNameName="container-fluid cl-main">
          {/* <div classNameName="card shadow-lg mb-3">
                        <div classNameName="card-header">
                            <h5 classNameName="find-inmate-head mb-0">
                                <i classNameName="fa fa-address-book"></i>&nbsp; Purchase Credits
                            </h5>
                        </div>

                    </div> */}
          <div>
            <div className="header-title">
              <h5>
                {/* <i className="fa fa-shopping-cart me-2"></i> */}
                {currentLang?.PurchaseCredits}
              </h5>
            </div>
          </div>
          <div className="card border-radius-all shadow-sm p-4 mb-5">
            <div className="row">
              <div className="col-md-7 col-xl-7">
                <div className="">
                  <div className="mb-3 mt-3">
                    <div
                      className="d-flex align-items-center"
                      role="alert"
                    >
                      <p className="font-size-14 mb-0 fw-500">
                        {currentLang?.PurchaseCreditsPage?.Success} {" "}<span className="text-default-success"> {currentLang?.PurchaseCreditsPage?.PLS_allow_15_min}</span>
                        {" "} {currentLang?.PurchaseCreditsPage?.AND_initiate_conversation}
                      </p>
                    </div>

                  </div>
                  {formData.InmateID > 0 && formData.InmateID !== "" && !isStatusDiv && (
                    <div className="mt-3 mb-3">
                      <div
                        className="alert-blue d-flex align-items-center gap-2 mb-3 mt-3"
                        role="alert">
                        <img src={info} className="margin-right-10" />
                        <div>
                          <b>{currentLang?.PurchaseCreditsPage?.Info}</b> {currentLang?.PurchaseCreditsPage?.Each_message_costs_one_credit_to_send} ${messageCost}.
                          {currentLang?.PurchaseCreditsPage?.A_minimum_purchase_of} <b><span>{creditsDetails}</span>&nbsp;{currentLang?.PurchaseCreditsPage?.credits}</b> {" "}
                          {currentLang?.PurchaseCreditsPage?.Is_Required_Amount}   ${(InmateDrpList?.length > 0 ? InmateDrpList[0]?.ProcessingFee : 1.5).toFixed(2)} {currentLang?.PurchaseCreditsPage?.All_Transactions}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="form-group">
                    <SelectInput
                      options={InmateDrpList}
                      value={formData.InmateID || null}
                      onChange={(selectedOption) => {
                        if (selectedOption === null) {
                          setIsDisabledCheckout(true);
                          setCreditAmount(0);
                          setProcessingFees(0);
                          setTotalAmount(0);
                          setFormData((prevState) => ({
                            ...prevState,
                            CreditBalance: "0.00",
                          }));
                          handleSelectChange(selectedOption, "InmateID");
                        } else {
                          handleSelectChange(selectedOption, "InmateID");
                        }
                      }}
                      name="InmateID" // Make sure the name is passed
                      labelKey="label"
                      valueKey="value"
                      isClearable={true}
                      placeholder={currentLang?.PurchaseCreditsPage?.Select_Inmate}
                      label={currentLang?.PurchaseCreditsPage?.Inmate}
                      required={true}
                      isDisabled={isDisabledInmateID}
                    //   handleBlur={handleBlur} // This will now work like with your TextInput
                    // errorMessage={errors.Inmate} // Make sure this is correctly passed
                    />
                  </div>
                </div>


                {formData.InmateID > 0 && formData.InmateID !== "" && !isStatusDiv && (
                  <div className="amount-add">
                    <h4 className="inner-heading">
                      {currentLang?.PurchaseCreditsPage?.Select_Credit_Amount}
                    </h4>

                    <div className="add-money">
                      <div
                        className={`money-grid ${selectedAmount === 5 ? "active" : ""}`}
                        onClick={() => { selectCreditAmount(5); setIsDisabledCheckout(false) }}
                      >
                        <a>
                          <span>+</span> $5.00{" "}
                        </a>
                      </div>
                      <div
                        className={`money-grid ${selectedAmount === 10 ? "active" : ""}`}
                        onClick={() => { selectCreditAmount(10); setIsDisabledCheckout(false) }}
                      >
                        <a >
                          <span>+</span> $10.00{" "}
                        </a>
                      </div>
                      {/* <div className="money-grid"><a href="#"><span>+</span> $15.00 </a></div>
                                                    <div className="money-grid"><a href="#"><span>+</span> $20.00 </a></div> */}
                    </div>

                  </div>
                )}
                {isStatusDiv && (<div
                  className="alert alert-warning text-center"
                  role="alert"
                >
                  {purchaseStatusDiv}
                </div>)
                }
              </div>
              <div className="col-md-5 col-lg-5">
                <div className="col-md-12 col-lg-12">
                  <div className="card border-radius-all">
                    <div classNameName="card-body">
                      <div className="pb-4 border-0 checkout-style">
                        <h3 className="heading text-center">
                          {currentLang?.PurchaseCreditsPage?.Checkout_Summary}
                        </h3>
                        <div className="current-credit-balance">
                          <div className="icon">
                            <img src={amountcash} />
                          </div>
                          <div className="credit-text">
                            <p>{currentLang?.PurchaseCreditsPage?.Current_Credit_Balance}</p>
                            <h4>
                              <span
                                className={`currency-sign ${formData.CreditBalance === 0 ? "text-default-red" : ""}`}
                                style={{ color: formData.CreditBalance === 0 ? "" : "inherit" }}
                              >
                                $
                              </span>
                              <span
                                className={`credit-amount ${formData.CreditBalance === 0 ? "text-default-red" : ""}`}
                                style={{ color: formData.CreditBalance === 0 ? "" : "inherit" }}
                              >
                                {formData.CreditBalance ? parseFloat(formData.CreditBalance).toFixed(2) : "0.00"}
                              </span>

                            </h4>
                          </div>
                        </div>
                        <ul className="charges-details">
                          <li className="charges-grid-list">
                            <div className="coentent font-14">{currentLang?.PurchaseCreditsPage?.Credit_Amount}</div>
                            <div className="font-14">
                              ${creditAmount.toFixed(2)}
                            </div>
                          </li>
                          <li className="charges-grid-list">
                            <div className="coentent font-14">{currentLang?.PurchaseCreditsPage?.Processing_Fee}</div>
                            {
                              <div className="font-14">
                                ${processingFee.toFixed(2)}
                              </div>
                            }
                          </li>
                          <li className="charges-grid-list">
                            <div className="coentent font-14">
                              {currentLang?.PurchaseCreditsPage?.Total_Amount}
                            </div>
                            <div className="amount ">
                              {" "}
                              ${(creditAmount + processingFee).toFixed(2)}
                            </div>
                          </li>
                        </ul>
                        <button
                          //disabled={true}
                          disabled={isDisabledCheckout}
                          className="p-2 btn btn-success w-100 fill-width mt-5 font-size-15"
                          onClick={handleCheckOut}
                        >
                          {isProcessing ? (
                            <>
                              <span className="me-2"> {currentLang?.Processing}</span>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>

                            </>
                          ) : (
                            <>
                              {currentLang?.PurchaseCreditsPage?.Proceed_To_Checkout}
                            </>
                          )}

                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {loader}
          <ConfirmationModal
            show={isStatusPopup}
            onConfirm={handleClickClose}
            title={currentLang?.Message}
            message={statusPopupMsg}
            showCancelButton={false} // Pass 'false' to hide the "No" button
            messageColor="#FF7F7F"
            onconfirmname={currentLang?.buttons?.OK}
            closeButton={false}
          />
        </div>
      </>
    </div>
  );
};

export default React.memo(PurchaseCredits);
